import { render, staticRenderFns } from "./ManageBanners_1.vue?vue&type=template&id=6c7e48c2&"
import script from "./ManageBanners_1.vue?vue&type=script&lang=js&"
export * from "./ManageBanners_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports